export const getUserType = userType => {
  switch (userType) {
    case 1: return 'Employee'
    case 2: return 'Manager'
    case 4: return 'Admin'
    default: return 'Admin'
  }
}